import { jsx as _jsx } from "react/jsx-runtime";
import { FieldViewType } from "../viewType";
import RadioFieldDetail from "./detail";
/** <b>Composant en mode consultation/detail d'un champ de type link</b>*/
export default function RadioFieldList(_a) {
    var record = _a.record, fieldName = _a.fieldName;
    return (_jsx(RadioFieldDetail, { viewType: FieldViewType.DETAIL, fieldName: fieldName, record: record }));
}
